<template>
    <div :style="{'max-width': '99%', 'width': '98%', 'margin-left': 'auto', 'margin-right': 'auto', 'margin-top': '10px'}">
        
        <!-- Receiving Details Modal with Simple Pop-Out 3D Effect -->
        <b-modal 
            id="modal-receiving-details" 
            scrollable 
            :title="`RECEIVING DETAILS - ${currentItem ? currentItem.product_name : ''} (${currentItem ? currentItem.product_sku : ''})`" 
            size="lg" 
            hide-footer
            centered
        >
            <div class="details-container">
                <b-row>
                    <!-- Left Column - Product Image with Simple 3D Effect -->
                    <b-col cols="12" md="6" class="mb-4 mb-md-0">
                        <div class="image-viewer-container">
                            <!-- Simple 3D Product Container -->
                            <div class="product-3d-container">
                                <div class="product-3d">
                                    <!-- 3D Image with Pop-Out Effect -->
                                    <div class="product-image-wrapper">
                                        <img 
                                            v-if="currentItem && currentItem.image_url"
                                            :src="currentItem.image_url"
                                            :alt="currentItem.product_name || 'Product Image'"
                                            class="product-image-3d"
                                            @error="handleImageError"
                                            @load="imageLoaded = true"
                                        />
                                        <div v-else class="no-image-placeholder">
                                            <b-icon icon="image" font-scale="3"></b-icon>
                                            <p>No Image Available..</p>
                                        </div>
                                    </div>
                                    
                                    <!-- Product Info Overlay -->
                                    <div class="product-info-overlay">
                                        <h6>{{ currentItem ? currentItem.product_name : '' }}</h6>
                                        <small>SKU: {{ currentItem ? currentItem.product_sku : '' }}</small>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Loading Indicator -->
                            <div v-if="imageLoading" class="text-center py-5">
                                <b-spinner small></b-spinner>
                                <p>Loading image...</p>
                            </div>
                        </div>
                    </b-col>
                    
                    <!-- Right Column - Product Details -->
                    <b-col cols="12" md="6">
                        <b-card class="details-card">
                            <b-row>
                                <b-col cols="6">
                                    <b-card-text><strong>Date/Time:</strong> {{ currentItem ? currentItem.ts : '' }}</b-card-text>
                                </b-col>
                                <b-col cols="6">
                                    <b-card-text><strong>SKU:</strong> {{ currentItem ? currentItem.product_sku : '' }}</b-card-text>
                                </b-col>
                            </b-row>
                            <b-row class="mt-2">
                                <b-col cols="12">
                                    <b-card-text><strong>Product Description:</strong> {{ currentItem ? currentItem.product_name : '' }}</b-card-text>
                                </b-col>
                            </b-row>
                            <b-row class="mt-2">
                                <b-col cols="6">
                                    <b-card-text><strong>Quantity:</strong> {{ currentItem ? currentItem.quantity : '' }}</b-card-text>
                                </b-col>
                                <b-col cols="6">
                                    <b-card-text><strong>Received By:</strong> {{ currentItem ? currentItem.username : '' }}</b-card-text>
                                </b-col>
                            </b-row>
                            <b-row class="mt-2">
                                <b-col cols="6">
                                    <b-card-text><strong>From:</strong> 
                                        <span v-if="currentItem && currentItem.source_locsub == '-1|-1'">
                                            MANUAL
                                        </span>
                                        <span v-else>{{ currentItem ? (packet.locsubsdict[currentItem.source_locsub] || currentItem.source_locsub) : '' }}</span>
                                    </b-card-text>
                                </b-col>
                                <b-col cols="6">
                                    <b-card-text><strong>To:</strong> {{ currentItem ? (packet.locsubsdict[currentItem.target_locsub] || currentItem.target_locsub) : '' }}</b-card-text>
                                </b-col>
                            </b-row>
                            
                            <!-- Image URL Info -->
                            <b-row class="mt-3" v-if="currentItem && currentItem.image_url">
                                <b-col cols="12">
                                    <b-card-text>
                                        <strong>Image URL:</strong>
                                        <a :href="currentItem.image_url" target="_blank" class="ml-1">
                                            {{ currentItem.image_url.substring(0, 50) }}...
                                        </a>
                                    </b-card-text>
                                </b-col>
                            </b-row>
                        </b-card>
                        
                        <!-- Image Actions -->
                        <div class="mt-3 text-center" v-if="currentItem && currentItem.image_url">
                            <b-button-group>
                                <b-button 
                                    variant="outline-success" 
                                    size="sm"
                                    @click="downloadImage"
                                    :disabled="!imageLoaded"
                                >
                                    <b-icon icon="download"></b-icon> Download Image
                                </b-button>
                                <b-button 
                                    variant="outline-info" 
                                    size="sm"
                                    @click="openImageInNewTab"
                                    :disabled="!imageLoaded"
                                >
                                    <b-icon icon="box-arrow-up-right"></b-icon> Open in New Tab
                                </b-button>
                            </b-button-group>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </b-modal>

        <div v-if="items_being_loaded == true">
            <loading :active="items_being_loaded"
                :can-cancel="false"
                :is-full-page="true">
            </loading>
        </div>
        

        <div v-else>
            <div>
                  <b-button variant="success" @click="fetch_init(false)">
                    <b-icon icon="arrow-clockwise"></b-icon> REFRESH RECEIVING LOGS
                </b-button>
            </div>
            <div class="d-flex flex-wrap align-items-center" style="margin-top:10px; gap: 5px; margin-bottom: 20px;">
              

                <!-- Date Range Filter -->
                <!-- <b-alert variant="info" show style="display: inline-block; width: 100%; max-width: 350px; margin-bottom: 0;">
                    <div>DATE RANGE</div>
                    <b-input-group>
                        <b-form-datepicker
                            v-model="startDate"
                            placeholder="Start Date"
                            :max="endDate || today"
                            style="width: 150px;"
                            @input="applyDateFilter"
                        ></b-form-datepicker>
                        <b-input-group-text>to</b-input-group-text>
                        <b-form-datepicker
                            v-model="endDate"
                            placeholder="End Date"
                            :min="startDate"
                            :max="today"
                            style="width: 150px;"
                            @input="applyDateFilter"
                        ></b-form-datepicker>
                    </b-input-group>
                </b-alert> -->

                <!-- Search -->
                <b-alert variant="success" show style="display: inline-block; width: 100%; max-width: 350px; margin-bottom: 0;">
                    <div>SEARCH BY SKU OR PRODUCT NAME</div>
                    <div style="display: inline-block; width: 100%;">
                        <b-input v-model="search_txt" style="width: 100%;" placeholder="Enter SKU or product name..." @keyup.enter="fetch_init(false)">
                            <template #append>
                                <b-button variant="outline-secondary" @click="fetch_init(false)">
                                    <b-icon icon="search"></b-icon>
                                </b-button>
                            </template>
                        </b-input>
                    </div>
                </b-alert>

                <!-- Location Filter (Admin only) -->
                <b-alert v-if="packet.userDetails.userrole === 'admin'" variant="info" show style="display: inline-block; width: 100%; max-width: 250px; margin-bottom: 0;">
                    <div>FILTER BY LOCATION</div>
                    <b-form-select :options="locationOptions" v-model="selectedLocationId" @change="fetch_init(false)" style="width: 100%;">
                    </b-form-select>
                </b-alert>

                <!-- Pagination Info -->
                <div style="margin-left: auto; font-size: 14px; color: #666;">
                    Showing {{ filteredItems.length }} of {{ totalItemsCount }} receiving records
                    <span v-if="isLoadingMore"> | Loading more...</span>
                </div>
            </div>

            <!-- Filters Toggle for Mobile -->
            <div v-if="isMobile" class="d-flex justify-content-between align-items-center mb-2 py-2">
                <b-button size="sm" variant="outline-primary" @click="filtersVisible = !filtersVisible">
                    <b-icon-funnel-fill class="mr-1" />
                    {{ filtersVisible ? "Hide Filters" : "Show Filters" }}
                </b-button>
            </div>

            <b-collapse :visible="!isMobile || filtersVisible" style="width: 100%; margin-bottom: 20px;">
                <b-card body-class="p-2">
                    <div class="d-flex flex-wrap align-items-center" style="gap: 10px;">
                        <!-- Quick Date Filters -->
                        <b-button-group size="sm">
                            <b-button variant="outline-secondary" @click="setDateRange('today')">Today</b-button>
                            <b-button variant="outline-secondary" @click="setDateRange('week')">This Week</b-button>
                            <b-button variant="outline-secondary" @click="setDateRange('month')">This Month</b-button>
                            <b-button variant="outline-secondary" @click="clearDateFilter">Clear Date</b-button>
                        </b-button-group>

                        <!-- Quick Stats -->
                        <div class="ml-3 d-flex flex-wrap" style="gap: 10px;">
                            <b-badge variant="primary">Total Items: {{ totalItemsCount }}</b-badge>
                            <b-badge variant="success">Today: {{ todayCount }}</b-badge>
                            <b-badge variant="info">This Week: {{ weekCount }}</b-badge>
                        </div>
                    </div>
                </b-card>
            </b-collapse>

            <div v-if="filteredItems.length > 0" class="diver mt-2" @scroll="handleScroll">
                <table style="width: 100%;">
                    <thead>
                        <tr>
                            <th class="srr clickable-header" @click="sortBy('ts')" style="width: 180px; background:lightgoldenrodyellow;">
                                DATE/TIME
                                <b-icon v-if="sortField === 'ts'" :icon="sortAsc ? 'sort-up' : 'sort-down'" class="ml-1"></b-icon>
                            </th>
                            <th class="srr clickable-header" @click="sortBy('product_sku')" style="width: 150px; background:lightgoldenrodyellow;">
                                SKU
                                <b-icon v-if="sortField === 'product_sku'" :icon="sortAsc ? 'sort-up' : 'sort-down'" class="ml-1"></b-icon>
                            </th>
                            <th class="srr clickable-header" @click="sortBy('product_name')" style="width: 250px; background:lightgoldenrodyellow;">
                                PRODUCT DESCRIPTION
                                <b-icon v-if="sortField === 'product_name'" :icon="sortAsc ? 'sort-up' : 'sort-down'" class="ml-1"></b-icon>
                            </th>
                            <th class="srr clickable-header" @click="sortBy('quantity')" style="width: 100px; background:lightgoldenrodyellow;">
                                QUANTITY
                                <b-icon v-if="sortField === 'quantity'" :icon="sortAsc ? 'sort-up' : 'sort-down'" class="ml-1"></b-icon>
                            </th>
                             <th class="srr clickable-header" @click="sortBy('source')" style="width: 200px; background:lightgoldenrodyellow;">
                               SHIP BY
                                <b-icon v-if="sortField === 'source'" :icon="sortAsc ? 'sort-up' : 'sort-down'" class="ml-1"></b-icon>
                            </th>
                            <th class="srr clickable-header" @click="sortBy('source_locsub')" style="width: 200px; background:lightgoldenrodyellow;">
                                FROM
                                <b-icon v-if="sortField === 'source_locsub'" :icon="sortAsc ? 'sort-up' : 'sort-down'" class="ml-1"></b-icon>
                            </th>
                            <th class="srr clickable-header" @click="sortBy('target_locsub')" style="width: 200px; background:lightgoldenrodyellow;">
                                TO
                                <b-icon v-if="sortField === 'target_locsub'" :icon="sortAsc ? 'sort-up' : 'sort-down'" class="ml-1"></b-icon>
                            </th>
                           
                            <th class="srr clickable-header" @click="sortBy('username')" style="width: 150px; background:lightgoldenrodyellow;">
                                RECEIVED BY
                                <b-icon v-if="sortField === 'username'" :icon="sortAsc ? 'sort-up' : 'sort-down'" class="ml-1"></b-icon>
                            </th>
                           <th class="srr sticky-last" style="width: 120px; background:lightgray;">ACTIONS</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(item, idx) in filteredItems" :key="item.id || idx">
                            <td class="srrv">
                               {{ formatDateTime(item.ts) }}
                            </td>
                            <td class="srrv">
                                {{ item.product_sku }}
                            </td>
                            <td class="srrv">
                                {{ item.product_name }}
                            </td>
                            <td class="srrv">
                                {{ item.quantity }}
                            </td>
                             <td class="srrv">
                                {{ item.source ? item.source.toUpperCase() : '' }}
                            </td>
                            <td class="srrv">
                                <span v-if="item.source_locsub == '-1|-1'">
                                   MANUAL
                                </span>
                                <span v-else>
                                    {{ packet.locsubsdict[item.source_locsub] || item.source_locsub }}
                                </span>
                            </td>
                            <td class="srrv">
                                {{ packet.locsubsdict[item.target_locsub] || item.target_locsub }}
                            </td>
                          

                            <td class="srrv">
                              {{ item.username ? item.username.toUpperCase() : '' }}
                            </td>
                            <td class="srrv sticky-last">
                                <b-button size="sm" variant="outline-info" @click="showItemDetails(item)" title="View Details">
                                    <b-icon icon="eye"></b-icon>
                                </b-button>
                                <b-button v-if="packet.userDetails.userrole === 'admin'" size="sm" variant="outline-secondary" @click="exportItem(item)" title="Export" class="ml-1">
                                    <b-icon icon="download"></b-icon>
                                </b-button>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <!-- Loading more indicator -->
                <div v-if="isLoadingMore" class="text-center p-3">
                    <b-spinner small></b-spinner>
                    <span style="margin-left: 10px;">Loading more records...</span>
                </div>

                <div v-if="!hasMore && filteredItems.length > 0" class="text-center p-2" style="background: #f8f9fa; border-top: 1px solid #dee2e6;">
                    <small class="text-muted">All {{ totalItemsCount }} records loaded</small>
                </div>
            </div>

            <div v-else-if="!items_being_loaded">
                <b-alert variant="warning" show>
                    <b-icon icon="exclamation-triangle" class="mr-2"></b-icon>
                    No receiving records found
                    <template v-if="search_txt">
                        for search term: "{{ search_txt }}"
                    </template>
                </b-alert>
            </div>

            <!-- Summary Stats Card -->
            <!-- <b-card v-if="filteredItems.length > 0" class="mt-3">
                <b-card-title>Receiving Summary</b-card-title>
                <b-row>
                    <b-col md="3" sm="6">
                        <b-card class="text-center bg-light">
                            <h5>Total Items Received</h5>
                            <h3 class="text-primary">{{ totalQuantity }}</h3>
                        </b-card>
                    </b-col>
                    <b-col md="3" sm="6">
                        <b-card class="text-center bg-light">
                            <h5>Unique Products</h5>
                            <h3 class="text-success">{{ uniqueProducts }}</h3>
                        </b-card>
                    </b-col>
                    <b-col md="3" sm="6">
                        <b-card class="text-center bg-light">
                            <h5>Users Involved</h5>
                            <h3 class="text-info">{{ uniqueUsers }}</h3>
                        </b-card>
                    </b-col>
                    <b-col md="3" sm="6">
                        <b-card class="text-center bg-light">
                            <h5>Average Quantity per receiving</h5>
                            <h3 class="text-warning">{{ averageQuantity }}</h3>
                        </b-card>
                    </b-col>
                </b-row>
            </b-card> -->
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    import global_vars from "@/utilities/global_vars";
    import Backer from "@/components/globals/Backer";
    import Requestor from "@/utilities/Requestor";
    import Loading from "vue-loading-overlay";
    import "vue-loading-overlay/dist/vue-loading.css";
    import { BIconFunnelFill } from "bootstrap-vue";

    export default {
        name: "ReceivingLogs",
        components: {
            Backer,
            Loading,
            BIconFunnelFill
        },
        data: function() {
            return {
                packet: {},
                // Main data
                allItems: [],
                filteredItems: [],
                currentOffset: 0,
                pageSize: 100,
                isLoadingMore: false,
                hasMore: true,
                totalItemsCount: 0,
                
                // Simple image loading
                imageLoading: false,
                imageLoaded: false,
                
                // Filters
                search_txt: '',
                startDate: null,
                endDate: null,
                selectedLocationId: null,
                today: moment().format('YYYY-MM-DD'),
                
                // Sorting
                sortField: 'ts',
                sortAsc: false,
                
                // Modal data
                currentItem: null,
                
                // UI State
                items_being_loaded: false,
                filtersVisible: false,
                isMobile: false,
                lastScrollTop: 0,
                searchTimeout: null
            }
        },
        computed: {
            hasImage() {
                return this.currentItem && this.currentItem.image_url && this.imageLoaded;
            },
            
            locationOptions() {
                const options = [{ value: null, text: 'ALL LOCATIONS' }];
                if (this.packet.locations && Array.isArray(this.packet.locations)) {
                    this.packet.locations.forEach(loc => {
                        const value = loc.value || loc.id || loc.location_id;
                        const text = loc.text || loc.name || loc.location_name;
                        options.push({ value, text });
                    });
                }
                return options;
            },
            
            todayCount() {
                const today = moment().format('YYYY-MM-DD');
                return this.allItems.filter(item => {
                    const itemDate = moment(item.ts, 'MM-DD-YYYY').format('YYYY-MM-DD');
                    return itemDate === today;
                }).length;
            },
            
            weekCount() {
                const weekStart = moment().startOf('week');
                return this.allItems.filter(item => {
                    const itemDate = moment(item.ts, 'MM-DD-YYYY');
                    return itemDate.isSameOrAfter(weekStart);
                }).length;
            },
            
            totalQuantity() {
                return this.filteredItems.reduce((sum, item) => sum + (parseInt(item.quantity) || 0), 0);
            },
            
            uniqueProducts() {
                const skus = new Set(this.filteredItems.map(item => item.product_sku));
                return skus.size;
            },
            
            uniqueUsers() {
                const users = new Set(this.filteredItems.map(item => item.username));
                return users.size;
            },
            
            averageQuantity() {
                if (this.filteredItems.length === 0) return 0;
                return Math.round(this.totalQuantity / this.filteredItems.length * 10) / 10;
            }
        },
        watch: {
            search_txt: function(newVal) {
                clearTimeout(this.searchTimeout);
                this.searchTimeout = setTimeout(() => {
                    if (newVal.length >= 2 || newVal === '') {
                        this.applyFilters();
                    }
                }, 500);
            }
        },
        methods: {
            showItemDetails(item) {
                this.currentItem = item;
                this.imageLoaded = false;
                this.imageLoading = true;
                this.$bvModal.show('modal-receiving-details');
                
                // Preload image
                if (item.image_url) {
                    const img = new Image();
                    img.onload = () => {
                        this.imageLoaded = true;
                        this.imageLoading = false;
                    };
                    img.onerror = () => {
                        this.imageLoading = false;
                        this.imageLoaded = false;
                    };
                    img.src = item.image_url;
                } else {
                    this.imageLoading = false;
                }
            },
            
            handleImageError() {
                this.imageLoaded = false;
                this.imageLoading = false;
            },
            
            downloadImage() {
                if (!this.currentItem || !this.currentItem.image_url) return;
                
                const link = document.createElement('a');
                link.href = this.currentItem.image_url;
                link.download = `${this.currentItem.product_sku}_${Date.now()}.jpg`;
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            },
            
            openImageInNewTab() {
                if (!this.currentItem || !this.currentItem.image_url) return;
                window.open(this.currentItem.image_url, '_blank');
            },
            
            handleResize() {
                this.isMobile = window.innerWidth < 768;
            },
            
            formatDateTime(dateTimeStr) {
                if (!dateTimeStr) return '';
                return dateTimeStr;
            },
            
            sortBy(field) {
                if (this.sortField === field) {
                    this.sortAsc = !this.sortAsc;
                } else {
                    this.sortField = field;
                    this.sortAsc = true;
                }
                this.applySorting();
            },
            
            applySorting() {
                this.filteredItems.sort((a, b) => {
                    let aVal = a[this.sortField];
                    let bVal = b[this.sortField];
                    
                    // Handle special cases
                    if (this.sortField === 'ts') {
                        aVal = moment(aVal, 'MM-DD-YYYY HH:mm:ss A').valueOf();
                        bVal = moment(bVal, 'MM-DD-YYYY HH:mm:ss A').valueOf();
                    } else if (this.sortField === 'quantity') {
                        aVal = parseInt(aVal) || 0;
                        bVal = parseInt(bVal) || 0;
                    }
                    
                    if (this.sortAsc) {
                        return aVal > bVal ? 1 : -1;
                    } else {
                        return aVal < bVal ? 1 : -1;
                    }
                });
            },
            
            setDateRange(range) {
                const today = moment();
                switch(range) {
                    case 'today':
                        this.startDate = today.format('YYYY-MM-DD');
                        this.endDate = today.format('YYYY-MM-DD');
                        break;
                    case 'week':
                        this.startDate = today.startOf('week').format('YYYY-MM-DD');
                        this.endDate = today.endOf('week').format('YYYY-MM-DD');
                        break;
                    case 'month':
                        this.startDate = today.startOf('month').format('YYYY-MM-DD');
                        this.endDate = today.endOf('month').format('YYYY-MM-DD');
                        break;
                }
                this.applyDateFilter();
            },
            
            clearDateFilter() {
                this.startDate = null;
                this.endDate = null;
                this.applyDateFilter();
            },
            
            applyDateFilter() {
                this.applyFilters();
            },
            
            applyFilters() {
                let filtered = [...this.allItems];
                
                // Apply search filter
                if (this.search_txt) {
                    const searchLower = this.search_txt.toLowerCase();
                    filtered = filtered.filter(item => 
                        (item.product_sku && item.product_sku.toLowerCase().includes(searchLower)) ||
                        (item.product_name && item.product_name.toLowerCase().includes(searchLower))
                    );
                }
                
                // Apply date filter
                if (this.startDate) {
                    filtered = filtered.filter(item => {
                        const itemDate = moment(item.ts, 'MM-DD-YYYY HH:mm:ss A').format('YYYY-MM-DD');
                        return itemDate >= this.startDate;
                    });
                }
                
                if (this.endDate) {
                    filtered = filtered.filter(item => {
                        const itemDate = moment(item.ts, 'MM-DD-YYYY HH:mm:ss A').format('YYYY-MM-DD');
                        return itemDate <= this.endDate;
                    });
                }
                
                // Apply location filter (for admin)
                if (this.selectedLocationId && this.packet.userDetails.userrole === 'admin') {
                    filtered = filtered.filter(item => {
                        if (item.target_locsub) {
                            const locId = item.target_locsub.split('|')[0];
                            return locId === this.selectedLocationId.toString();
                        }
                        return false;
                    });
                }
                
                this.filteredItems = filtered;
                this.applySorting();
            },
            
            async fetchProducts(offset = 0, limit = null, append = false) {
                if (this.isLoadingMore && append) return;
                
                this.isLoadingMore = true;
                if (!append) {
                    this.items_being_loaded = true;
                }
                
                try {
                    let path = "/api/inventory/get_inventory_move_logs/";
                    let data = {
                        limit: limit || this.pageSize,
                        offset: offset
                    };
                    
                    if (this.search_txt) {
                        data.search_txt = this.search_txt;
                    }
                    
                    // Add location filter for non-admin users
                    if (this.packet.userDetails.userrole !== 'admin' && this.packet.userDetails.properties && this.packet.userDetails.properties.location_id) {
                        data.location_id = this.packet.userDetails.properties.location_id;
                    }
                    
                    // Add admin location filter
                    if (this.selectedLocationId && this.packet.userDetails.userrole === 'admin') {
                        data.location_id = this.selectedLocationId;
                    }
                    
                    const response = await new Promise((resolve, reject) => {
                        Requestor.getSyncP(path, data, this, resolve, reject);
                    });
                    
                    if (response.data.result) {
                        const newItems = response.data.result;
                        
                        if (append) {
                            this.allItems = [...this.allItems, ...newItems];
                        } else {
                            this.allItems = newItems;
                        }
                        
                        this.applyFilters();
                        this.hasMore = newItems.length === this.pageSize;
                        this.currentOffset = offset + newItems.length;
                        
                        if (!append) {
                            this.totalItemsCount = this.allItems.length;
                        }
                    }
                } catch (error) {
                    console.error('Error fetching receiving logs:', error);
                    this.$bvToast.toast(
                        "Error fetching receiving records",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                } finally {
                    this.items_being_loaded = false;
                    this.isLoadingMore = false;
            }
            },
            
            async loadMore() {
                if (this.isLoadingMore || !this.hasMore) return;
                await this.fetchProducts(this.currentOffset, this.pageSize, true);
            },
            
            handleScroll(event) {
                const container = event.target;
                
                if (container.scrollTop === this.lastScrollTop) return;
                
                this.lastScrollTop = container.scrollTop;
                
                const scrollBottom = container.scrollHeight - container.scrollTop - container.clientHeight;
                
                if (scrollBottom < 100 && !this.isLoadingMore && this.hasMore) {
                    this.loadMore();
                }
            },
            
            async fetch_init(first = true) {
                if (first) {
                    this.search_txt = '';
                    this.startDate = null;
                    this.endDate = null;
                    this.selectedLocationId = null;
                }
                
                this.currentOffset = 0;
                this.hasMore = true;
                this.allItems = [];
                this.filteredItems = [];
                await this.fetchProducts(0, this.pageSize, false);
            },
            
            exportItem(item) {
                // Create CSV content
                const headers = ['Date/Time', 'SKU', 'Product Name', 'Quantity', 'From', 'To', 'Received By'];
                const data = [
                    item.ts,
                    item.product_sku,
                    item.product_name,
                    item.quantity,
                    item.source_locsub == '-1|-1' ? 'MANUAL' : (this.packet.locsubsdict[item.source_locsub] || item.source_locsub),
                    this.packet.locsubsdict[item.target_locsub] || item.target_locsub,
                    item.username
                ];
                
                const csvContent = [
                    headers.join(','),
                    data.map(val => `"${val}"`).join(',')
                ].join('\n');
                
                const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                const link = document.createElement('a');
                const url = URL.createObjectURL(blob);
                
                const filename = `receiving_${item.product_sku}_${moment().format('YYYY-MM-DD_HH-mm-ss')}.csv`;
                
                link.setAttribute('href', url);
                link.setAttribute('download', filename);
                link.style.visibility = 'hidden';
                
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                
                this.$bvToast.toast(
                    "Receiving record exported successfully",
                    {title: "Success", autoHideDelay: 2000, variant:"success"}
                );
            },
            
            exportAll() {
                const headers = ['Date/Time', 'SKU', 'Product Name', 'Quantity', 'From', 'To', 'Received By'];
                const csvContent = [
                    headers.join(','),
                    ...this.filteredItems.map(item => [
                        item.ts,
                        item.product_sku,
                        item.product_name,
                        item.quantity,
                        item.source_locsub == '-1|-1' ? 'MANUAL' : (this.packet.locsubsdict[item.source_locsub] || item.source_locsub),
                        this.packet.locsubsdict[item.target_locsub] || item.target_locsub,
                        item.username
                    ].map(val => `"${val}"`).join(','))
                ].join('\n');
                
                const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                const link = document.createElement('a');
                const url = URL.createObjectURL(blob);
                
                const filename = `receiving_logs_${moment().format('YYYY-MM-DD_HH-mm-ss')}.csv`;
                
                link.setAttribute('href', url);
                link.setAttribute('download', filename);
                link.style.visibility = 'hidden';
                
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                
                this.$bvToast.toast(
                    `Exported ${this.filteredItems.length} records to CSV`,
                    {title: "Success", autoHideDelay: 2000, variant:"success"}
                );
            }
        },
        mounted: function() {
            this.handleResize();
            window.addEventListener("resize", this.handleResize);
        },
        beforeDestroy() {
            window.removeEventListener("resize", this.handleResize);
        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            
            // Initialize location dictionary
            if (this.packet.locsubsdict) {
                // Convert to object if it's an array
                if (Array.isArray(this.packet.locsubsdict)) {
                    const dict = {};
                    this.packet.locsubsdict.forEach(item => {
                        if (item.value && item.text) {
                            dict[item.value] = item.text;
                        }
                    });
                    this.packet.locsubsdict = dict;
                }
            } else {
                this.packet.locsubsdict = {};
            }
            
            let that = this;
            this.fetch_init(true);
        }
    }
</script>

<style scoped>
/* Fixed table styles */
.diver {
    overflow: auto;
    width: 100%;
    height: 600px;
    border: 1px solid #dee2e6 !important;
}

.diver table {
    table-layout: fixed;
    width: 100%;
    border-collapse: separate !important;
    border-spacing: 0;
    border: 1px solid #495057 !important;
}

.diver table tbody tr td,
.diver table thead tr th {
    border: 1px solid #dee2e6 !important;
    box-sizing: border-box;
}

.diver td,
.diver th {
    border: 1px solid #dee2e6 !important;
    box-sizing: border-box;
    position: relative;
}

.diver th {
    background-color: white;
    border-bottom: 2px solid #495057 !important;
    position: sticky;
    top: 0;
    z-index: 2;
}

.diver th:hover {
    background-color: #f8f9fa;
}

/* Sticky last column for actions */
.diver td.sticky-last,
.diver th.sticky-last {
    position: sticky;
    right: 0;
    z-index: 3;
    background-color: white;
    border-left: 2px solid #495057 !important;
}

.diver th.sticky-last {
    z-index: 4;
}

/* Ensure borders are visible on all sides */
.diver table,
.diver tr,
.diver td,
.diver th {
    border-style: solid !important;
    border-width: 1px !important;
}

/* Cell styles */
.srr {
    font-size: 13px;
    text-align: center;
    font-weight: bold;
    padding: 8px 4px;
}

.srrv {
    font-size: 12px;
    text-align: center;
    background: white;
    border: 1px solid #495057 !important;
    padding: 8px 4px;
    min-height: 40px;
    vertical-align: middle;
}

.diver tbody tr:hover td {
    background-color: #f8f9fa !important;
}

.clickable-header {
    cursor: pointer;
    transition: all 0.2s ease;
}

.clickable-header:hover {
    background: #b8b8b8 !important;
}

.details-container {
    padding: 15px;
}

.badge {
    font-size: 12px;
    padding: 4px 8px;
}

/* Color-coded headers - matching your products table style */
.srr[style*="background:lightblue"] {
    background-color: #d1ecf1 !important;
    border-color: #17a2b8 !important;
}

.srr[style*="background:lightgreen"] {
    background-color: #d1f7d1 !important;
    border-color: #28a745 !important;
}

.srr[style*="background:lightgoldenrodyellow"] {
    background-color: #fef9e7 !important;
    border-color: #f1c40f !important;
}

.srr[style*="background:lightcoral"] {
    background-color: #f8d7da !important;
    border-color: #dc3545 !important;
}

.srr[style*="background:lightpink"] {
    background-color: #ffd1dc !important;
    border-color: #e91e63 !important;
}

.srr[style*="background:lightseagreen"] {
    background-color: #d1f2eb !important;
    border-color: #20c997 !important;
}

.srr[style*="background:lightsalmon"] {
    background-color: #ffe5d0 !important;
    border-color: #fd7e14 !important;
}

.srr[style*="background:lightgray"] {
    background-color: #e9ecef !important;
    border-color: #6c757d !important;
}

/* Button spacing in action column */
.srrv .btn {
    margin: 2px;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
    .diver {
        overflow-x: auto;
        overflow-y: auto;
    }
    
    .diver th,
    .diver td {
        font-size: 10px;
        padding: 4px 2px;
    }
    
    .diver td.sticky-last,
    .diver th.sticky-last {
        position: static !important;
        left: auto !important;
        right: auto !important;
        z-index: auto !important;
    }
    
    .d-flex.flex-wrap {
        flex-direction: column;
        align-items: stretch;
    }
    
    .d-flex.flex-wrap > * {
        width: 100% !important;
        max-width: 100% !important;
        margin-bottom: 10px;
    }
    
    .badge {
        font-size: 10px;
        padding: 2px 4px;
    }
    
    .srrv .btn {
        padding: 2px 4px;
        font-size: 10px;
    }
}

/* Loading states */
.diver.loading {
    opacity: 0.7;
    pointer-events: none;
}

/* Focus styles for accessibility */
.diver td:focus,
.diver th:focus {
    outline: 2px solid #007bff;
    outline-offset: -2px;
    z-index: 3;
}

/* Simple Pop-Out 3D Effect Styles */
.image-viewer-container {
    border: 1px solid #dee2e6;
    border-radius: 15px;
    padding: 20px;
    background: #f8f9fa;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    height: 100%;
    display: flex;
    flex-direction: column;
}

.product-3d-container {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.product-3d {
    flex: 1;
    position: relative;
    border-radius: 10px;
    overflow: hidden;
    background: white;
}

/* Simple 3D Pop-Out Effect */
.product-image-wrapper {
    width: 100%;
    height: 320px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background: linear-gradient(135deg, #ffffff 0%, #f5f7fa 100%);
    position: relative;
    overflow: hidden;
    border-radius: 8px;
    box-shadow: 
        0 10px 30px rgba(0, 0, 0, 0.15),
        0 0 0 1px rgba(0, 0, 0, 0.1);
    
    /* 3D Effect */
    transform: perspective(1000px) translateZ(20px);
    transition: transform 0.3s ease;
}

.product-image-wrapper:hover {
    transform: perspective(1000px) translateZ(30px);
    box-shadow: 
        0 15px 40px rgba(0, 0, 0, 0.2),
        0 0 0 1px rgba(0, 0, 0, 0.1);
}

.product-image-3d {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    
    /* Enhanced 3D effect on image */
    filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.2));
    transform: perspective(1000px) translateZ(10px);
    transition: transform 0.3s ease, filter 0.3s ease;
}

.product-image-wrapper:hover .product-image-3d {
    filter: drop-shadow(0 15px 30px rgba(0, 0, 0, 0.3));
    transform: perspective(1000px) translateZ(15px);
}

.no-image-placeholder {
    text-align: center;
    color: #6c757d;
    padding: 40px;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-radius: 8px;
    border: 2px dashed #dee2e6;
}

.no-image-placeholder .b-icon {
    color: #adb5bd;
    margin-bottom: 10px;
}

.product-info-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
    color: white;
    padding: 15px;
    transform: translateZ(15px);
}

.product-info-overlay h6 {
    margin: 0;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.product-info-overlay small {
    font-size: 11px;
    opacity: 0.9;
}

/* Details Card */
.details-card {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border: none;
}

.details-card .card-text {
    font-size: 14px;
    margin-bottom: 8px;
}

.details-card .card-text strong {
    color: #495057;
    min-width: 120px;
    display: inline-block;
}

/* Image URL link */
.details-card a {
    word-break: break-all;
    font-size: 12px;
}

/* Responsive Design */
@media (max-width: 768px) {
    .image-viewer-container {
        padding: 15px;
    }
    
    .product-image-wrapper {
        height: 220px;
        padding: 15px;
    }
    
    .product-3d {
        perspective: 500px;
    }
}

/* Simple shadow for depth */
.product-image-wrapper::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 10%;
    right: 10%;
    height: 20px;
    background: radial-gradient(ellipse at center, rgba(0,0,0,0.2) 0%, transparent 70%);
    border-radius: 50%;
    filter: blur(5px);
    opacity: 0.7;
    z-index: -1;
    transition: all 0.3s ease;
}

.product-image-wrapper:hover::after {
    bottom: -15px;
    left: 5%;
    right: 5%;
    height: 30px;
    opacity: 0.9;
}
</style>


// WEBPACK FOOTER //
// src/components/Receiving/Logs.vue